export default "__VITE_ASSET__DPoFqkBi__"